import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../../css/RepoAnalysis.css";


function RepoAnalysisDashboard() {
  const [analysisData, setAnalysisData] = useState([]) // stores and manages all of or metrics data received from the backend
  const [errorMsg, setErrorMsg] = useState("") // stores and manages error Messages
  const [uuidCredit, setUuidCredit] = ""
  const params = useParams()

  var MetricMap = {
    "bugs": "Bugs",
    "vulnerabilities": "Vulnerabilities",
    "security_rating": "Security rating",
    "security_hotspots": "Security hotspots",
    "code_smells": "Code smells",
    "ncloc_language_distribution": "Lines of code"
  }

  useEffect(
      setUuidCredit(localStorage.getItem('uuidCredit')),
      axios.get(process.env.REACT_APP_URL_RELATIVE_RATINGS_NODE +`/api/detailed?id=${params.id}`)
      .then((response=>response.json())).then((result) => {
        console.log(result)
        result.errors === undefined ? setAnalysisData(result.component) : setErrorMsg("The following link cannot be analyzed" /*setErrorMsg(result.errors[0].msg*/ )
      }).catch((error) => {
        console.error("Error: ", error)
        setErrorMsg("Cannot analyze the following link")
      }), []
  )

  return (
    <div>
      <div className="DisplayCode">
        {(uuidCredit === "") ? 
        <>Please login to see the github account analysis Dashboard</> : 
        (analysisData.length===0) ? 
          ( <> </>) : 
          (
            [<div className="project-info">
              <div className = "author">Author: {analysisData.user_name}</div>
            </div>,
            
            analysisData.map( repo => (
              <div className = "project"> Project: {repo.repo_name}</div>,
              repo.map(metric => {
                  <div className="metric">
                      <div className="metricName metric-elem" key={metric.metric}> {MetricMap[metric.metric]} </div>
                      <div className="quantity metric-elem" key={metric.value}> {metric.value.includes(";", )? metric.value.split(";").map(lang=>(<div className="lang">{lang.replace("=", " - ")}</div>)): metric.value} </div>
                  </div>
              })
              ))]
        )}
      </div>
    </div>
  )
}

export default RepoAnalysisDashboard